<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-card
      class="my-card-style"
    >
      <v-card
        dark
        flat
      >
        <v-img
          :height="300"
          cover
          :src="image"
          gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
        >
          <v-container class="fill-height">
            <v-row
              align="center"
              justify="center"
            >
              <div class="my-date-style">
                {{ currentDateTime }}
              </div>
            </v-row>
          </v-container>
        </v-img>
      </v-card>
    </v-card>
    <v-card-text class="py-0">
      <v-timeline
        align-top
        dense
      >
        <v-timeline-item
          v-for="(item, index) in latestTenServiceProviderActivities"
          :key="index"
          color="#FF3700"
          small
        >
          <v-row class="pt-1">
            <v-col cols="3">
              <p
                class="my-p-style"
              >
                <font
                  class="font-my-style"
                >
                  {{ item.checkin_time | convertStringToLocalDatetime }}
                </font>
              </p>
            </v-col>
            <v-col>
              <strong>Activity {{ index + 1 }}</strong>
              <br>
              <br>
              <div>
                <p
                  class="my-p-style"
                >
                  Location:-
                  <font
                    class="font-my-style"
                  >
                    {{ item.site.name }}
                  </font>
                </p>
              </div>
              <div>
                <p
                  class="my-p-style"
                >
                  Type:-
                  <font
                    class="type-style"
                  >
                    {{ item.type }}
                  </font>
                </p>
              </div>
              <div>
                <p
                  class="my-p-style"
                >
                  Checked-In Time:-
                  <font
                    class="font-my-style"
                  >
                    {{ item.checkin_time | convertStringToLocalDatetime }}
                  </font>
                </p>
              </div>
              <div>
                <p
                  v-if="item.checkout_time !== null"
                  class="my-p-style"
                >
                  Checked-Out Time:-
                  <font
                    class="font-my-style"
                  >
                    {{ item.checkout_time | convertStringToLocalDatetime }}
                  </font>
                </p>
                <p
                  v-else
                  class="my-p-style"
                >
                  Checked-Out Time:-
                  <font
                    class="not-checked-out-style"
                  >
                    Active*
                  </font>
                </p>
              </div>
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>

<script>
import moment from 'moment';
import { cdnUrl } from 'src/app-globals';
import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'RecentServiceProviderActivity',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
    convertStringToLocalDatetime (stringDatetime) {
      return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
    },
    },
    data: () => ({
      image: `${cdnUrl}/website/ActivityImage.jpg`,
      tab: null,
      currentDateTime: null,
      loading: false,
    }),
    computed: {
     latestTenServiceProviderActivities () {
        const list = this.$store.getters['serviceproviders/getRecentServiceProviderActivities'];
        const sortedList = list.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        return sortedList;
     },
    },
    async mounted () {
      await this.fetchRecentServiceProviderActivities();
    },
    created () {
      this.currentDateTime = moment().format('MMMM Do YYYY, h:mm:ss A');
      setInterval(() => this.liveDateTime());
      },
    methods: {
      async fetchRecentServiceProviderActivities () {
        this.loading = true;
        await this.$store.dispatch('serviceproviders/fetchRecentServiceProviderActivities', {
          params: {
            limit: 10,
          },
          serviceProviderId: this.$route.params.externalId,
        });
        this.loading = false;
        },
      liveDateTime () {
        this.currentDateTime = moment().format('MMMM Do YYYY, h:mm:ss A');
      },
    },
  };
</script>
<style scoped>
.my-date-style {
  font-size: 25px;
  font-weight: bold;
}
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
  text-transform: capitalize;
}
.my-p-style {
    font-size: 16px;
    font-weight: bold;
    color: #546E7A;
    font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.not-checked-out-style {
  font-weight: bold;
  font-size: 15px;
  color:#2E7D32;
}
.type-style {
  font-weight: bold;
  font-size: 15px;
  color: #FF3700;
  text-transform: capitalize;
}
</style>
